module.exports = __webpack_public_path__ + "img/investissement3.32fa14ce.png";